module.exports = __webpack_public_path__ + "img/00233065004255.63af10be.png";